import React from 'react';

import { Button as AntdButton } from 'antd';

import './FormDelete.less';

interface FormDeleteProps {
  name?: string;
  utilisateurDestinataire?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function FormDelete({
  name,
  utilisateurDestinataire,
  onClose,
  onConfirm,
}: FormDeleteProps): React.ReactElement {
  return (
    <>
      <h3>
        Suppression de <b>{name}</b> à destination des {utilisateurDestinataire}
      </h3>
      <div className="textContainer">
        <div>Cette action est irréversible</div>
        <div>Êtes-vous sûr de vouloir supprimer ce document ?</div>
      </div>
      <div className="buttonContainer">
        <AntdButton onClick={onClose}>Annuler</AntdButton>
        <AntdButton onClick={onConfirm} type="primary">
          Supprimer
        </AntdButton>
      </div>
    </>
  );
}
